const env = process.env.NODE_ENV || "development";

const domainEnvironment = {
  development: {
        domainAdminSide: "http://localhost:3001",
        domainUserSide: "http://localhost:3000",
        domainName:"",
  },
  production: {
      domainAdminSide: "https://ytuongqhbaisonghong-admin.cgis.asia",
      domainUserSide: "https://ytuongqhbaisonghong.cgis.asia",
      domainName:"cgis.asia",
  },
};

module.exports = domainEnvironment[env];
